import { RotateCcw, ZoomIn, ZoomOut } from "lucide-react";

import AnalyticsChartToolbarButton from "../../AnalyticsChartToolbarButton";

interface AnalyticsMermaidZoomControlsProps {
  onFit: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const AnalyticsMermaidZoomControls = ({
  onFit,
  onZoomIn,
  onZoomOut,
}: AnalyticsMermaidZoomControlsProps) => (
  <div className="absolute right-2 top-2 z-10 flex items-center gap-0.5 rounded-md border border-gray-200 bg-white/95 p-0.5 shadow-sm backdrop-blur-sm">
    <AnalyticsChartToolbarButton
      ariaLabel="Zoom in"
      icon={ZoomIn}
      onClick={onZoomIn}
      tooltip="Zoom in"
    />
    <AnalyticsChartToolbarButton
      ariaLabel="Zoom out"
      icon={ZoomOut}
      onClick={onZoomOut}
      tooltip="Zoom out"
    />
    <AnalyticsChartToolbarButton
      ariaLabel="Fit diagram"
      icon={RotateCcw}
      onClick={onFit}
      tooltip="Fit diagram"
    />
  </div>
);

export default AnalyticsMermaidZoomControls;
